import {
  takeEvery, put, call,
} from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, LOGIN_SUCCESS } from './actionTypes';
import { apiError } from './actions';

// Include Both Helper File with needed methods
import { post } from '../../../helpers/api_helper';
import * as url from '../../../helpers/url_helper';

function* loginUser({ payload: { creds, history, redirectTo } }) {
  try {
    const postJwtLogin = (data) => post(url.POST_JWT_LOGIN, data);

    const user = yield call(postJwtLogin, {
      id: creds.user_id,
      pin: creds.pin,
    });

    localStorage.setItem('authUser', JSON.stringify(user));

    yield put({ type: LOGIN_SUCCESS, payload: { user } });
    history.push(redirectTo || '/dashboard');
  } catch (error) {
    if (error.response.status === 401) {
      yield put(apiError('Invalid username/password'));
    } else {
      yield put(apiError(error.message));
    }
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem('authUser');
    localStorage.removeItem('roles');

    history.push('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
